import React, {useState} from "react";

// import { Link } from "react-router-dom";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import { useHistory } from "react-router-dom";
/// Image
import profile from "../../../images/profile/17.jpg";
import avatar from "../../../images/avatar/1.jpg";
import { Dropdown } from "react-bootstrap";
import { Redirect } from 'react-router-dom';

const Header = ({ onNote }) => {
   const history = useHistory()
   const [logoutFlag, setLogout] = useState();
   var path = window.location.pathname.split("/");
   var name = path[path.length - 1].split("-");
   var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
   var finalName = filterName
   if(path && path[1] == 'ticket'){
      finalName = "BGTKT" + filterName
   } else if(path && path[1] == 'ticketlist'){
      finalName = "Ticket List"
   } else if(path && path[1] == 'sms-list'){
      finalName = "SMS List"
   } else if(path && path[1] == 'sms'){
      finalName = process.env.REACT_APP_SMS_PREFIX + filterName
   } else if(path && path[1] == 'contact-list'){
      finalName = "Contact List"
   } else if(path && path[1] == 'note-list'){
      finalName = "Note List"
   } else if(path && path[1] == 'customer-list'){
      finalName = "Customer List"
   } else {
      finalName = "Ticket List"
   }
   // var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
   // var finalName = filterName.includes("app")
   //    ? filterName.filter((f) => f !== "app")
   //    : filterName.includes("ui")
   //    ? filterName.filter((f) => f !== "ui")
   //    : filterName.includes("uc")
   //    ? filterName.filter((f) => f !== "uc")
   //    : filterName.includes("basic")
   //    ? filterName.filter((f) => f !== "basic")
   //    : filterName.includes("jquery")
   //    ? filterName.filter((f) => f !== "jquery")
   //    : filterName.includes("table")
   //    ? filterName.filter((f) => f !== "table")
   //    : filterName.includes("page")
   //    ? filterName.filter((f) => f !== "page")
   //    : filterName.includes("email")
   //    ? filterName.filter((f) => f !== "email")
   //    : filterName.includes("ecom")
   //    ? filterName.filter((f) => f !== "ecom")
   //    : filterName.includes("chart")
   //    ? filterName.filter((f) => f !== "chart")
   //    : filterName.includes("editor")
   //    ? filterName.filter((f) => f !== "editor")
   //    : filterName;

   const logout = () => {
         localStorage.removeItem("bgToken");
         localStorage.removeItem("login")
         localStorage.removeItem("userType")
         localStorage.removeItem("profilepic")
         localStorage.removeItem("ticketProfileName")

         localStorage.removeItem("ticket_column_title")
         localStorage.removeItem("ticket_column_type")
         localStorage.removeItem("ticket_column_owner")
         localStorage.removeItem("ticket_column_order")
         localStorage.removeItem("ticket_column_created")
         localStorage.removeItem("ticket_column_status")
         localStorage.removeItem("ticket_column_action")

         localStorage.removeItem("unreadSmsCount")
         localStorage.removeItem("unreadTicketCount")
         localStorage.removeItem("unreadContactCount")
         localStorage.removeItem("unreadNoteCount")
         localStorage.removeItem("unreadCustomerCount")

         setLogout({})
         history.push("/login");
         window.location.reload();
         //setLogout({})
         // <Redirect to="/login" />;
   }
   const reloadPage = () => {
      window.location.reload();
   }
   return (
      <div className="header">
         <div className="header-content">
            <nav className="navbar navbar-expand">
               <div className="collapse navbar-collapse justify-content-between">
                  <div className="header-left">
                     <div
                        className="dashboard_bar"
                        style={{ textTransform: "capitalize" }}
                     >
                        {!finalName
                           ? "Ticket List"
                           : finalName}
                     </div>
                  </div>
                  {localStorage.getItem("ticketProfileName") ? 
                  <div className="displayProfileNameHeader">
                     {"Hello "} <span style={{fontWeight : "700"}}>{localStorage.getItem("ticketProfileName")} {" 😊"}</span>
                  </div> : ""}

                  <ul className="navbar-nav header-right">
                  <Dropdown
                        as="li"
                        className="nav-item dropdown header-profile"
                     >
 <Dropdown.Toggle
                           variant=""
                           as="a"
                           className="nav-link i-false"
                           href="#"
                           role="button"
                           data-toggle="dropdown"
                        >
                            {/* <button className="dropdown-item ai-icon" onClick={() => reloadPage()}> */}
                           <i class="fa fa-refresh" style={{marginLeft : "0.5rem"}}onClick={() => reloadPage()} aria-hidden="true"></i>
                           {/* </button> */}
                        </Dropdown.Toggle>
                        </Dropdown>
                     <Dropdown
                        as="li"
                        className="nav-item dropdown header-profile"
                     >
                        
                        <Dropdown.Toggle
                           variant=""
                           as="a"
                           className="nav-link i-false"
                           href="#"
                           role="button"
                           data-toggle="dropdown"
                        >
                           <img src={localStorage.getItem("profilepic") ? process.env.REACT_APP_IMAGE_URL + localStorage.getItem("profilepic")  : profile} width={20} alt="profile" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu align="right" className="mt-2 form-border-color">
                           {/* <Link
                              to="/app-profile"
                              className="dropdown-item ai-icon"
                           >
                              <svg
                                 id="icon-user1"
                                 xmlns="http://www.w3.org/2000/svg"
                                 className="text-primary"
                                 width={18}
                                 height={18}
                                 viewBox="0 0 24 24"
                                 fill="none"
                                 stroke="currentColor"
                                 strokeWidth={2}
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              >
                                 <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                 <circle cx={12} cy={7} r={4} />
                              </svg>
                              <span className="ml-2">Profile </span>
                           </Link> */}
                           
                           
                           <button
                              // to="/page-login"
                              className="dropdown-item ai-icon"
                              onClick={() => logout()}
                              style={{borderRadius : "1.25rem", backgroundColor : "#FE634E", borderColor : "#FE634E !important", color:"white"}}
                           >
                              {/* <svg
                                 id="icon-logout"
                                 xmlns="http://www.w3.org/2000/svg"
                                 className="text-danger"
                                 width={18}
                                 height={18}
                                 viewBox="0 0 24 24"
                                 fill="none"
                                 stroke="currentColor"
                                 strokeWidth={2}
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              >
                                 <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                 <polyline points="16 17 21 12 16 7" />
                                 <line x1={21} y1={12} x2={9} y2={12} />
                              </svg> */}
                              <span className="ml-2">Logout </span>
                           </button>
                        </Dropdown.Menu>
                     </Dropdown>
                  </ul>
               </div>
            </nav>
         </div>
      </div>
   );
};

export default Header;
